import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import { Typewriter } from "react-simple-typewriter";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import {
  ChatUserIcon,
  CloseIcon,
  CopyIcon,
  CrownIcon,
  ReturnIcon,
  SendIcon,
  SoundIcon,
  StopSoundIcon,
} from "../../../assets/icons/iconshere";
import ChatBotImg from "../../../assets/images/chatbotimg.png";
import ChatBotWhiteImg from "../../../assets/images/chatbotimgwhite.png";
import { BreadRightArrow } from "../../../SvgIconsData";
import ProPopup from "../../layouts/ProPopup";

const ChatBot = ({ moduleUUID, sopSuggestions, showPopup, setShowPopup }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const body = document.body;
  const textAreaRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [height, setHeight] = useState("26px");
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [overflowY, setOverflowY] = useState("hidden");
  const [textLoading, setTextLoading] = useState(false);
  const [copyText, setCopyText] = useState("copy");
  const [isSpeaking, setIsSpeaking] = useState({
    id: null,
    status: false,
  });

  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const showChatBox = showPopup.chatbot;

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const handleCopy = (text) => () => {
    // Create a textarea element
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);

    // Select the text inside the textarea
    textarea.select();

    // Copy the selected text to the clipboard
    document.execCommand("copy");

    // Remove the textarea element
    document.body.removeChild(textarea);
    setCopyText("copied");
    setTimeout(() => setCopyText("copy"), 1000);
  };

  const [chatboxActive, setChatboxActive] = useState(false);
  let userName = (userData?.user?.name || "").split(" ");
  let initials =
    userName.length >= 1
      ? userName[0].charAt(0).toUpperCase() +
        (userName.length > 1 ? userName[userName.length - 1].charAt(0).toUpperCase() : "")
      : null;

  const toggleSpeak = (text, index) => {
    if (isSpeaking.status && isSpeaking.id === index) {
      window.speechSynthesis.cancel();
      setIsSpeaking({ id: null, status: false });
    } else {
      const utterance = new SpeechSynthesisUtterance(text);
      const voices = window.speechSynthesis.getVoices();
      utterance.voice = voices[2];
      window.speechSynthesis.speak(utterance);
      setIsSpeaking({ id: index, status: true });
    }
  };

  const openChatBox = () => {
    // setShowChatBox(!showChatBox);
    setShowPopup((prev) => ({ chatbot: !prev.chatbot, aiAnalytics: false }));
    if (!showChatBox) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    updateTextAreaHeight();
  };

  const updateTextAreaHeight = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      setHeight(`${textAreaRef.current.scrollHeight}px`);
      if (textAreaRef.current.scrollHeight > 100) {
        setOverflowY("auto");
      } else {
        setOverflowY("hidden");
      }
    }
  };

  const handleSubmit = async () => {
    setChatboxActive(true);
    setInputValue("");
    if (inputValue.trim().length === 0) {
      return;
    }

    const userInput = inputValue.trim();

    setMessages((prevMessages) => [...prevMessages, { request: userInput }]);
    setTextLoading(true);
    try {
      const { data } = await axios.post(`${configData.config.OPEN_AI_URL}/question`, {
        uuid: moduleUUID,
        query: userInput,
      });

      setTextLoading(false);
      setMessages((prevMessages) => [...prevMessages, { response: data }]);
    } catch (error) {
      console.log(error);
      setTextLoading(false);
      setMessages((prevMessages) => [
        ...prevMessages,
        { response: "Sorry for the inconvenience, please try after some time." },
      ]);
    }
  };
  const handleSubmitSuggetions = async (question) => {
    setChatboxActive(true);
    if (question.trim().length === 0) {
      return;
    }

    const userInput = question.trim();

    setMessages((prevMessages) => [...prevMessages, { request: userInput }]);
    setTextLoading(true);
    try {
      const { data } = await axios.post(`${configData.config.OPEN_AI_URL}/question`, {
        uuid: moduleUUID,
        query: userInput,
      });

      setTextLoading(false);
      setMessages((prevMessages) => [...prevMessages, { response: data }]);
    } catch (error) {
      console.log(error);
      setTextLoading(false);
      setMessages((prevMessages) => [
        ...prevMessages,
        { response: "Sorry for the inconvenience, please try after some time." },
      ]);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleSpeechEnd = () => {
      setIsSpeaking((prev) => ({
        ...prev,
        status: false,
      }));
    };

    window.speechSynthesis.addEventListener("end", handleSpeechEnd);

    return () => {
      window.speechSynthesis.removeEventListener("end", handleSpeechEnd);
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    window.speechSynthesis.getVoices();
    updateTextAreaHeight();
  }, [inputValue]);

  return (
    <>
      <div className="chat-bot">
        <div className="chat-parent">
          {userPlan && userPlan?.courseDetail?.aiAssist ? (
            <span
              className="bot-here"
              onClick={() => {
                openChatBox();
                setChatboxActive(false);
              }}
            >
              <img src={ChatBotImg} alt="chabot" />
              {!showChatBox && <p className="tooltip">AI Chatbot</p>}
            </span>
          ) : (
            <button className="bot-here" onClick={() => setOpenPro()}>
              <span>
                <CrownIcon />
                <p> Unlock Chatbot </p>
              </span>
            </button>
          )}

          {showChatBox && (
            <span className="chat-here">
              <div className="chat-content">
                {messages.length === 0 ? (
                  <>
                    <div className="greet-screen w-100">
                      <img src={ChatBotWhiteImg} alt="chatbot white" />
                      <p>
                        {" "}
                        Welcome {userData.user.name} <br />
                        How can I help you today?{" "}
                      </p>
                      <div className="temp-ques">
                        {sopSuggestions.length > 0 &&
                          sopSuggestions.map((question, index) => {
                            return (
                              <span key={index} onClick={() => handleSubmitSuggetions(question)} className="ques-item">
                                {question}
                                <span className="click-que">
                                  <BreadRightArrow />
                                </span>
                              </span>
                            );
                          })}
                      </div>
                    </div>
                  </>
                ) : null}
                {messages.length === 0 ? (
                  <span className="close-btn" onClick={openChatBox}>
                    <CloseIcon />
                  </span>
                ) : (
                  <div className="close-pannel">
                    <span className="close-btn" onClick={openChatBox}>
                      <ReturnIcon />
                    </span>

                    <span className="close-btn" onClick={openChatBox}>
                      <CloseIcon />
                    </span>
                  </div>
                )}
                <div className="for-prompts">
                  {messages.length > 0 &&
                    messages.map((message, i) => {
                      return (
                        <React.Fragment key={i}>
                          {message.request && (
                            <div className="promptext">
                              {initials ? (
                                <span className="user-ini"> {initials} </span>
                              ) : (
                                <span className="user-ini" style={{ backgroundColor: "transparent" }}>
                                  {" "}
                                  <ChatUserIcon />{" "}
                                </span>
                              )}
                              <span className="promt-info">
                                <p>You</p>
                                <p>{message.request}</p>
                              </span>
                            </div>
                          )}
                          {i === messages.length - 1 && textLoading ? (
                            <div className="promptext">
                              <img src={ChatBotImg} className="user-ini ai" alt="chatbot-img" />
                              <span className="promt-info">
                                <p>Assistant</p>
                                <p className="w-100">
                                  <Skeleton count={2} width="20vw" baseColor="#566FF950" highlightColor="#FF7C7C50" />
                                </p>
                              </span>
                            </div>
                          ) : null}
                          {message.response && (
                            <div className="promptext">
                              <img src={ChatBotImg} className="user-ini ai" alt="chatbot-img" />
                              <span className="promt-info">
                                <p>Assistant</p>
                                {chatboxActive ? (
                                  i === messages.length - 1 ? (
                                    <Typewriter words={[`${message.response}`]} typeSpeed={20} />
                                  ) : (
                                    <p>{message.response}</p>
                                  )
                                ) : (
                                  <p>{message.response}</p>
                                )}
                                <div className="mini-featurs">
                                  <Tooltip title={isSpeaking.status && isSpeaking.id === i ? "Stop" : "Read Aloud"}>
                                    <span onClick={() => toggleSpeak(message.response, i)}>
                                      {isSpeaking.status && isSpeaking.id === i ? <StopSoundIcon /> : <SoundIcon />}
                                    </span>
                                  </Tooltip>
                                  <Tooltip title={copyText}>
                                    <span onClick={handleCopy(message.response)}>
                                      <CopyIcon />
                                    </span>
                                  </Tooltip>
                                </div>
                              </span>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  <div ref={messagesEndRef} />
                </div>
                <div className="for-input">
                  <textarea
                    ref={textAreaRef}
                    value={inputValue}
                    onChange={handleChange}
                    placeholder="Type your message here"
                    style={{ overflowY: overflowY }}
                    onKeyDown={handleKeyDown}
                  />
                  <span onClick={handleSubmit} className="send-btn">
                    <SendIcon />
                  </span>
                </div>
              </div>
            </span>
          )}
        </div>
      </div>

      {showChatBox && <div className="showoverlay" onClick={openChatBox}></div>}

      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default ChatBot;
